export default __webpack_public_path__ + "static/media/icon-descontos.daf460c8.svg";